<div [formGroup]="detailsForm" class="station-assignment-details no-field-space">

  <sc-flex >

    <mat-form-field class="input">
      <input matInput matInputInteger name="posX" formControlName="posX"
        placeholder="{{'position x' | translate:['tmc-yard.widgets.yard-map-configuration.position-x', translationService.language]}}"
        [required]="true" type="NUMBER">
    </mat-form-field>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <mat-form-field class="input">
      <input matInput matInputInteger name="posY" formControlName="posY"
        placeholder="{{'position y' | translate:['tmc-yard.widgets.yard-map-configuration.position-y', translationService.language]}}"
        [required]="true" type="NUMBER">
    </mat-form-field>

  </sc-flex>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <button mat-stroked-button class="delete-button" type="button" (click)="removeStationAssignment()"
    [disabled]="stationAssignment==null"> <sc-icon iconClass="fa-trash"></sc-icon> </button>
</div>